export default {
  evidence_division: {
      id: "Id",
      code: "Code",
      name: "Name",
      description: "Description",
      active: "Active",
      createdAt: "Created At",
      updatedAt: "Updated At",
      create: "Create New Evidence Division",
      update: "Update Evidence Division",
    }
}